export default "__VITE_ASSET__937038ea__"